<template>
  <div class="second-layer-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'second_layer_list'}" class="float-left mr-1 main-link">{{$t('second_layer.second_layer')}}</router-link> / {{(uuid === 'create') ? $t('second_layer.new') : $t('second_layer.second_layer_update')}}
                </h3>
              </strong>
            </div>

            <div class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('second_layer.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0"/>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-15">
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('second_layer.basic_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <b-form-group v-bind:label="$t('second_layer.sku')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                            class="form-control border-radius-4px"
                            v-model="item.sku"
                            :state="!$v.item.sku.$invalid"
                            :aria-describedby="'sku-feedback'"
                            :disabled="uuid !== 'create' && uuid !== undefined"
                    />
                    <b-form-invalid-feedback :id="'sku-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                <div class="form-group row" >
                  <legend class="col-sm-2 col-form-label">{{$t('second_layer.second_layer_name')}}</legend>
                  <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                    <b-form-input type="text"
                                  :name="`name[${lang}]`"
                                  class="form-control border-radius-4px"
                                  v-model="item.name[lang]"
                                  v-bind:placeholder="$t('common.text_' + lang)"
                    />
                  </div>
                </div>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('second_layer.short_name')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                            type="text"
                            class="form-control border-radius-4px col-sm-5"
                            v-model="item.short_name">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('first_layer.main_description')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <count-text-area
                        v-model="item.main_description[lang]"
                        v-bind:placeholder="$t('common.text_' + lang)">
                      </count-text-area>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('second_layer.piece')" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.piece" :value="2" :uncheckedValue="1"/>
                  </b-form-group>
                </b-col>
                
                <b-col cols="12" class="row m-0 p-0">
                  <div class="col-sm-6 row m-0 p-0 pt-3 mb-3" v-for="(urlValue, keyName, index) in imageData" :key="`${keyName}-${imageDataKey}`">
                    <legend class="col-sm-4 col-form-label" :class="{'text-right': (index % 2)}">
                      {{$t('second_layer.'+keyName)}}
                      <b-tooltip :target="'image-' + keyName" placement="top">
                        <div class="text-left" v-html="getImageHelpInfo('second_layer', keyName)"></div>
                      </b-tooltip>
                    </legend>
                    <div class="col-sm-8 img-min-height">
                      <b-form-file :id="keyName" @change="previewImage" accept="image/*"
                                   :placeholder="$t('message.choose_a_file')"></b-form-file>
                      <ImagePreview :url="urlValue" :keyUrl="keyName" @onDeleteImage="handleDeleteImage" />             
                    </div>
                  </div>
                </b-col>

                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('second_layer.only_lunch')" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.only_lunch" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('second_layer.sequence')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                            type="number"
                            class="form-control border-radius-4px col-sm-5"
                            v-model="item.sequence">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-form>
            </b-collapse>
            <div slot="footer">
              <div class="back-button">
                <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.push({name: 'second_layer', query: {rollback: 1}})"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              </div>
              <div class="btn-save">
                <button type="button" class=" pull-right btn bg-main border-radius-4px pl-3 pr-3" v-on:click="saveSecondLayer()" :disabled="checkSubmit() "> {{$t('common.save')}}</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import ImagePreview from '@/components/Partials/ImagePreview'
  import CountTextArea from '../../../components/Partials/CountTextArea'

  let vm = null

  export default {
    name: 'SecondLayerForm',
    props: {
     uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    components: {
      cSwitch,
      ImagePreview,
      CountTextArea
    },
    data: function () {
      return {
        item: {
          uuid: '',
          sku: '',
          name: {},
          short_name: '',
          sequence: 0,
          piece: 1,
          image: {},
          active: 1,
          only_lunch: 0,
          main_description: {}
        },
        basicInformationStatus: true,
        imageData: {},
        imageDataKey: 0,
        images: ['desktop_thumbnail', 'desktop_detail', 'mobile_thumbnail', 'mobile_detail'],
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        sku: {
          required
        },
        name: {
          required
        },
      }
    },
    computed: {},
    methods: {
      handleDeleteImage(imageKey) {
        vm.imageData[`${imageKey}`] = ''
        vm.item.image[`${imageKey}`] = ''
        vm.imageDataKey += 1
      },
      checkSubmit: function () {
        let validateName = false
        let form = vm.$v.item.$invalid
        return form || validateName
      },
      saveSecondLayer () {
        let data = JSON.parse(JSON.stringify(vm.item))
        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.item.image) {
          if (vm.item.image[i] && vm.item.image[i].type != undefined) {
            formData.append(i, vm.item.image[i])
          } else {
            oldUrl[i] = vm.item.image[i]
          }
        }
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        vm.axios.menu.uploadImageSecondLayer(formData, config, function (response) {
          data.image = {}
          for (let i in response.data.data.item) {
            data.image[i] = response.data.data.item[i]
          }
          for (let i in oldUrl) {
            data.image[i] = oldUrl[i]
          }
          if(Object.getOwnPropertyNames(data.image).length > 0) {
            vm.imageData = data.image
          }

          if (vm.item.uuid === '' || vm.item.uuid === 'create') {
            vm.axios.menu.createSecondLayer(data, function (response) {
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              this.$forceUpdate()
            }, function () {
            })
          } else {
            vm.axios.menu.updateSecondLayer(data, function (response) {
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              this.$forceUpdate()
            }, function () {
            })
          }
        })
      },
      /**
       * get list categories for select box
       */
      getDetailSecondLayer () {
        vm.axios.menu.getDetailSecondLayer(vm.uuid, function(response){
          let item = response.data.data.item
          if (item.name == null) {
            item.name = {'ja': '', 'en': ''}
          }
          if (item.main_description == null) {
            item.main_description = {}
            for (let lang of vm.$store.getters.languages) {
              item.main_description[lang] = ''
            }
          }

          vm.item = item
          let data = {}
          for (let i in vm.images) {
            if (!vm.images.hasOwnProperty(i)) continue
            data[vm.images[i]] = vm.item.image[vm.images[i]] != null ? vm.item.image[vm.images[i]] : ''
          }
          if(Object.getOwnPropertyNames(data).length > 0) {
            vm.imageData = data
          }
        })
      },

      /**
       * update status of customise session
       */
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
      /**
       * preview image after select
       * @param event
       */
      previewImage (event) {
        let input = event.target

        if (input.files && input.files[0]) {
          let reader = new FileReader()

          reader.onload = (e) => {
            this.imageData[input.id] = e.target.result
          }
          // this.imageData = []
          let data = {}
          for (let i in this.images) {
            data[this.images[i]] = this.imageData[this.images[i]]
          }
          this.imageData = data
          reader.readAsDataURL(input.files[0])
          this.item.image = this.item.image ? this.item.image : {}
          this.item.image[input.id] = input.files[0]
        }
      },
    },
    created: function () {
      vm = this
    },
    updated: function () {
    },
    mounted: function () {
      let data = {}
      for (let i in vm.images) {
        if(!vm.images.hasOwnProperty(i)) continue;
        data[vm.images[i]] = ''
      }
      vm.imageData = data

      if (vm.uuid !== 'create' && vm.uuid !== undefined) {
        vm.getDetailSecondLayer()
      }
    }
  }
</script>

<style scoped>

  .img-min-height {
    height: 200px;
  }

  .back-button {
    padding-left: 25px;
    width: 95px;
    float: left;
  }

  .second-layer-form .switch.switch-icon{
    margin-top: 5px;
  }

  .second-layer-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .second-layer-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .second-layer-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .second-layer-form .btn-save{
    float: right !important;
    padding-right: 22px;
    margin-right: 0px !important;
    box-sizing: border-box;
    text-align: right;
  }
  /*END Form Wizard*/
</style>

<style>
  .preview-image {
    width: 100%;
  }

  .second-layer-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .second-layer-form div.header,
  .second-layer-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .second-layer-form .btn-primary .fa{
    font-size: 20px;
  }
  .second-layer-form .btn-primary {
    color: #0091ff;
    background-color: transparent;
  }
  .second-layer-form .btn-primary:hover{
    color: #0091ff;
    background-color: transparent;
  }
  .pt-05{
    padding: 0.5rem;
  }
  .pb-15{
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/second-layer/BaseForm.vue